import { PluginIcon as IPcIcon, Plugin } from '@next-space/fe-svg-icon';
import type { FC } from 'react';
import { cx } from '../cx';
import { useIsDarkMode } from '../utils/get-dark';
import type { ComponentProp } from './types';
import { IconSizeStyle } from './types';

export type PluginIconName = keyof typeof Plugin;
const pcIconKeys = Object.keys(Plugin);

export interface PluginIconProp extends ComponentProp {
  size?: keyof typeof IconSizeStyle;
  name?: PluginIconName | null;
}

export const PluginIcon = (props: PluginIconProp) => {
  const isDarkMode = useIsDarkMode();
  const { size = 'normal', className = '', style = {}, onClick } = props;
  let { name } = props;

  if (!name) return null;

  if (name.startsWith('DmIc')) {
    // eslint-disable-next-line no-console
    console.error('不能直接使用DmIc的Icon，请使用MIc。dark环境下会自动转为DmIc');
    return null;
  }

  if (name.startsWith('MIc') && isDarkMode) {
    name = name.replace('MIc', 'DmIc') as PluginIconName;
    if (!pcIconKeys.includes(name)) {
      // eslint-disable-next-line no-console
      // console.error('缺少深色模式icon', name);
      name = name.replace('DmIc', 'MIc') as PluginIconName;
    }
  }

  if (!pcIconKeys.includes(name)) {
    // eslint-disable-next-line no-console
    console.error('缺少icon', name);
    return null;
  }

  return (
    <IPcIcon
      data-icon={name}
      className={cx('flex-shrink-0 fill-current inline', IconSizeStyle[size], className, {
        'cursor-pointer': Boolean(onClick),
      })}
      onClick={onClick}
      style={
        {
          verticalAlign: '-0.15em',
          ...(style as any),
        } as any
      }
      aria-hidden="true"
      name={name as PluginIconName}
    />
  );
};
